import React from "react"
import Brochure from "../Brochure"

export default function DocumentsSlide(props) {
  const { slides } = props

  const renderSlides = () => {
    return (
      slides &&
      slides.map(item => {
        return (
          <div>
            <Brochure text={item.title} link={item.file} blank />
          </div>
        )
      })
    )
  }
  return (
    <div style={{ display: "flex" }}>
      {renderSlides()}
    </div>
  )
}
